import { createSelector } from 'reselect';

const selector = state => state.order;

export default createSelector([selector], data => data);
